import { isUserOnMobile, isUserOnTV } from "@sinclair-digital/cabin-auth-library";
import { createContext, useContext } from "react";

export interface DeviceContext {
    isMobile: boolean;
    isTV: boolean;
}

export const DeviceContext = createContext<DeviceContext>({
    isMobile: false,
    isTV: false,
});

export function useDevice() {
    return useContext(DeviceContext);
}

export function DeviceProvider({ children }: { children: React.ReactNode }) {
    const isMobile = isUserOnMobile();
    const isTV = isUserOnTV();

    return <DeviceContext.Provider value={{ isMobile, isTV }}>{children}</DeviceContext.Provider>;
}

export default DeviceContext;
